var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#E84142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9102 34.9414H13.0664C12.0508 34.9414 11.543 34.9414 11.2305 34.7461C10.8984 34.5312 10.7031 34.1797 10.6641 33.7891C10.6445 33.418 10.8984 32.9883 11.4063 32.1094L23.3789 10.9961C23.8867 10.0977 24.1406 9.64844 24.4727 9.49219C24.8242 9.31641 25.2344 9.31641 25.5859 9.49219C25.918 9.64844 26.1719 10.0977 26.6797 10.9961L29.1406 15.293L29.1602 15.3125C29.707 16.2695 29.9805 16.7578 30.1172 17.2656C30.2539 17.832 30.2539 18.418 30.1172 18.9648C30 19.4727 29.7266 19.9805 29.1602 20.957L22.8711 32.0898L22.8516 32.1094C22.3047 33.0859 22.0117 33.5742 21.6211 33.9453C21.1914 34.3555 20.6836 34.6484 20.1367 34.8047C19.6289 34.9414 19.0625 34.9414 17.9102 34.9414ZM30.1758 34.9414H37.1289C38.1641 34.9414 38.6719 34.9414 38.9844 34.7461C39.3164 34.5312 39.5313 34.1602 39.5508 33.7695C39.5703 33.418 39.3164 32.9883 38.8477 32.168C38.8281 32.1484 38.8086 32.1094 38.7891 32.0898L35.3125 26.1328L35.2734 26.0742C34.7852 25.2539 34.5313 24.8242 34.2188 24.668C33.8672 24.4922 33.457 24.4922 33.1055 24.668C32.793 24.8242 32.5195 25.2734 32.0117 26.1523L28.5156 32.0898L28.4961 32.1094C27.9883 32.9883 27.7344 33.418 27.7539 33.7891C27.7734 34.1797 27.9883 34.5508 28.3203 34.7656C28.6328 34.9414 29.1406 34.9414 30.1758 34.9414Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.4d1dd1fbcaf87328934042e51a8016f2.svg";
export { ForwardRef as ReactComponent };